// Utility functions for handling SSN values.
export function extractDigits(value: string | null | undefined): string {
  return String(value ?? '').replace(/\D/g, '');
}

// This function extracts the last 4 digits of an SSN from a given value.
export function getExistingSsnDigits(value?: string | null): string {
  return extractDigits(value);
}

// This function resolves the SSN value to be submitted based on the raw input value and the existing value (if any).
export function resolveSsnForSubmit(
  rawValue: string | null | undefined,
  options?: {
    isEditMode?: boolean;
    existingValue?: string | null;
  }
): string {
  const enteredDigits = extractDigits(rawValue);

  if (!options?.isEditMode) {
    return enteredDigits;
  }

  const existingDigits = getExistingSsnDigits(options.existingValue);
  if (enteredDigits.length === 4 && existingDigits.length >= 5) {
    return `${existingDigits.slice(0, 5)}${enteredDigits}`;
  }

  return enteredDigits;
}
